<template>
	<div class="container" style="background-color: #ffffff;">
		<van-sticky>
		<div class="main_box">
			<div class="main_box_main">
				<div class="top_box"
					data-aos="fade-in"
					data-aos-duration="400"
					data-aos-delay="100"
					data-aos-offset="0"
					data-aos-once="true"
				>
					<div class="left">
						<img src="../../assets/img/logo_color.png" @click="goIndex" />
					</div>
					<div class="right">
						<div class="nav_box">
							<div class="nav_el" :class="pagename == 'Aiiso Depatment' ? 'actived' : ''" @click="navHandleUrl('https://ne.ucsd.edu/')">Aiiso Dept.</div>
							<!-- <div class="nav_el" :class="pagename == 'Media Room' ? 'actived' : ''" @click="navHandle('/media-room')">Media Room</div> -->
							<div class="nav_el" :class="pagename == 'Careers' ? 'actived' : ''" @click="navHandle('/careers')">Careers</div>
							<!-- <div class="nav_el" :class="pagename == 'Contact' ? 'actived' : ''" @click="navHandle('/contact')">Contact</div> -->
							<div class="nav_el nav_el3" style="color: #f16000;font-weight: bold;" :class="pagename == 'Buy AL21' ? 'actived' : ''" @click="navHandleUrl('https://al21.com/')">
								<van-icon name="shopping-cart-o" class="icon_buy" size="22px" color="#f16000" style="top: 4px;" /> Buy at @AL21
							</div>
							<div class="search_box">
								<van-icon name="search" size="20px" style="position: relative;top: 10px;font-weight: bold;" @click="searchClick" />
							</div>
							<div class="nav_el2">
								<img src="../../assets/img_public/subscribe_button.webp" @click="goSubscribe" />
							</div>
						</div>
					</div>
				</div>
				<div class="bot_box">
					<div class="nav_box">
						<div
							v-for="(value1, index1) in navData"
							:key="index1"
							class="nav_el"
							:class="value1.catname == pagename ? 'actived' : ''"
							@mouseover="navOver(value1)"
							@click="navHandle2(1, value1)"
						>
							{{ value1.catname }}
							<van-icon v-if="value1.children.length > 0" name="play" color="#999999" style="transform: rotate(90deg);position: relative;top: 3px;" />
							<div v-if="value1.children && isShowChild" class="nav_el_box" @mouseleave="navOut">
								<div v-for="(value2, index2) in value1.children" :key="index2" class="nav_el_el" @click.stop="navHandle2(2, value2)">{{ value2.catname }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!--search-->
		<van-popup v-model="searchShow" closeable style="background-color: transparent;">
			<div class="search_box">
				<input
					v-model="searchVal"
					name="searchVal"
					ref="inputDom"
					class="input_el"
					placeholder="Search..."
					autocomplete="on"
					@keyup.enter="searchEnter"
				/>
			</div>
		</van-popup>
		<!--search-->
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
		</van-sticky>
	</div>
</template>

<script>
import { navList } from '@/api/public';
export default {
	components:{
		//
	},
	props: ['pageName'],
	data() {
		return {
			isLoading: true,  //界面loading
			navData: JSON.parse(sessionStorage.getItem('navData')),
			lang: sessionStorage.getItem('lang'),
			isShowChild: false,  //二级导航显示/隐藏
			searchShow: false,
			searchVal: '',
			pagename: this.pageName,
		}
	},
	created(){
		let that = this;
		if(!JSON.parse(sessionStorage.getItem('navData'))) {
			navList({language: 'en'}).then(res => {
				if(res.data.length > 0) {
					that.navData = res.data;
					sessionStorage.setItem('navData', JSON.stringify(res.data));
				}
			});
		}else {
			that.navData = JSON.parse(sessionStorage.getItem('navData'));
		}
		// Subscribe
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	methods: {
		//跳转订阅
		goSubscribe() {
			let that = this;
			// window.location.href = 'https://pages.cordx.com/cordx-poc-newsletter';
			if(that.$route.path != '/cordx-poc-newsletter') {
				that.isShow = false;
				that.$router.push({ path: '/cordx-poc-newsletter', });
			}else {
				window.location.reload();
			}
			// window.open('https://pages.cordx.com/cordx-poc-newsletter');
		},
		navOver(value) {
			let that = this;
			if(value.children.length > 0) {
				that.isShowChild = true;
			}else {
				that.isShowChild = false;
			}
		},
		navOut() {
			let that = this;
			that.isShowChild = false;
		},
		//搜索
		searchEnter() {
			let that = this;
			if(that.$route.path != '/search') {
				sessionStorage.setItem('searchVal', that.searchVal);
				that.$router.push({ path: '/search', });
			}else {
				sessionStorage.setItem('searchVal', that.searchVal);
				window.location.reload();
			}
			// if(that.searchVal) {
			// 	that.$router.push({ path: '/search', query: { val: that.searchVal, } });
			// }else {
			// 	that.$router.push({ path: '/search', });
			// }
		},
		//点击搜索
		searchClick() {
			let that = this;
			that.searchShow = true;
			setTimeout(() => {
				this.$refs.inputDom.focus();
			}, 500);
		},
		//跳转导航
		navHandleUrl(path) {
			window.open(path);
		},
		navHandle(path) {
			let that = this;
			if(that.$route.path != path) {
				that.$router.push({ path: path, });
			}
		},
		navHandle2(type, value) {
			let that = this;
			if(type == 1) {
				if(value.url == '/products'){
					if(that.$route.name == 'Products') {
						that.$router.push({ name: 'Products', params: { cateId: 'all', } });
						window.location.reload();
					}else {
						that.$router.push({ name: 'Products', params: { cateId: 'all', } });
					}
				}else if(value.url == '/become-a-distributor') {
					// window.open('https://pages.cordx.com/become-a-distributor');
					that.$router.push({ path: '/become-a-distributor' });
				}else {
					if(that.$route.path != value.url) {
						that.$router.push({ path: value.url, });
					}
				}
			}else if(type == 2) {
				// console.log(that.$route.name);
				// return false;
				if(that.$route.name == 'Products') {
					that.$router.push({ name: 'Products', params: { cateId: value.custom, } });
					window.location.reload();
				}else {
					that.$router.push({ name: 'Products', params: { cateId: value.custom, } });
				}
			}
		},
		//跳转首页
		goIndex() {
			let that = this;
			if(that.$route.path != '/') {
				that.$router.push({ path: '/', });
			}
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	width: 100%;
	background-color: #ffffff;
	// box-shadow: 0 0 5px #c8c8c8;
	.main_box_main{
		width: 1140px;
		margin: 0 auto;
		padding: 2px 0 0 0;
		/*搜索*/
		.search_box{
			background-color: transparent;
			.input_el{
				width: 980px;
				background-color: transparent;
				border: none;
				border-bottom: 1px solid #ffffff;
				color: #ffffff;
				height: 75px;
				line-height: 75px;
				font-size: 50px;
				text-align: center;
			}
		}
		/*底部*/
		.bot_box{
			padding: 12px 10px 0 10px;
			.nav_box{
				position: relative;
				padding-bottom: 5px;
				.nav_el{
					display: inline-block;
					margin-right: 30px;
					padding: 10px 0 2px 0;
					font-size: 20px;
					cursor: pointer;
					border-bottom: 3px solid #ffffff;
					position: relative;
					.icon_buy{
						font-weight: bold;
						color: #000000;
					}
					.nav_el_box{
						position: absolute;
						left: 0;
						z-index: 2;
						margin-top: 15px;
						padding: 0 50px;
						border-radius: 8px;
						box-shadow: 0 0 8px rgb(100, 100, 100, 0.2);
						background-color: #ffffff;
						.nav_el_el{
							padding: 10px 0;
							color: #0B318F;
							white-space: nowrap;
							font-size: 20px;
						}
						.nav_el_el:hover{
							color: #0066D4;
						}
					}
				}
				.nav_el:hover{
					color: #0066D4;
					border-bottom: 3px solid #0066D4;
					.icon_buy{
						color: #0066D4 !important;
					}
				}
				.nav_el.actived{
					color: #0066D4;
					border-bottom: 3px solid #0066D4;
					.icon_buy{
						color: #0066D4 !important;
					}
				}
			}
		}
		/*顶部*/
		.top_box{
			display: flex;
			align-items: center;
			text-align: right;
			padding: 10px 10px 0 10px;
			.left{
				width: auto;
				img{
					width: 150px;
					cursor: pointer;
				}
			}
			.right{
				flex: 1;
				.nav_box{
					position: relative;
					.search_box{
						margin-left: 30px;
						display: inline-block;
						cursor: pointer;
					}
					.nav_el2{
						display: inline-block;
						margin-left: 30px;
						position: relative;
						top: -6px;
						img{
							width: 110px;
							cursor: pointer;
						}
					}
					.nav_el{
						display: inline-block;
						position: relative;
						top: 7px;
						margin-left: 30px;
						padding-bottom: 8px;
						font-size: 20px;
						cursor: pointer;
						border-bottom: 3px solid #ffffff;
					}
					.nav_el:hover{
						color: #0066D4;
						border-bottom: 3px solid #0066D4;
					}
					.nav_el3:hover{
						border-bottom: none;
					}
					.nav_el.actived{
						color: #0066D4;
						border-bottom: 3px solid #0066D4;
					}
				}
			}
		}
	}
}
</style>
